import * as yup from 'yup';

export const discordRoleCreateSchema = yup.object().shape({
  emoji: yup.string().required('Emoji obligatoire'),
  name: yup.string().required('Le nom est obligatoire'),
});
